import { render, staticRenderFns } from "./MemberInfoCommon.vue?vue&type=template&id=979d2b06&scoped=true&"
import script from "./MemberInfoCommon.vue?vue&type=script&lang=js&"
export * from "./MemberInfoCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979d2b06",
  null
  
)

export default component.exports